import { useTranslation } from '@frontend/i18n';
import { Modal, ModalControlModalProps, Text } from '@frontend/design-system';

export type DisconnectProviderModalProps = {
  modalProps: ModalControlModalProps;
  onSubmit: () => Promise<void>;
  isMutating: boolean;
};
export const DisconnectProviderModal = ({ modalProps, isMutating, onSubmit }: DisconnectProviderModalProps) => {
  const { t } = useTranslation('payments');

  return (
    <Modal {...modalProps} maxWidth={600} minWidth={600}>
      <Modal.Header onClose={modalProps.onClose}>{t('Disconnect CareCredit Account')}</Modal.Header>
      <Modal.Body>
        <Text>
          {t(
            'Disconnecting this CareCredit account will stop all CareCredit activity in your practice. After disconnecting:'
          )}
        </Text>

        <ul>
          <li>{t('You won’t be able to create new CareCredit payment plans.')}</li>
          <li>{t('Existing CareCredit plans and transactions will remain visible for reference.')}</li>
          <li>{t('Patients will no longer be able to pay using CareCredit until an account is reconnected.')}</li>
        </ul>

        <Text>{t('You can reconnect a CareCredit account at any time.')}</Text>
      </Modal.Body>
      <Modal.Footer
        primary={{
          destructive: true,
          loading: isMutating,
          disabled: isMutating,
          label: t('Yes, Disconnect'),
          onClick: onSubmit,
        }}
        secondary={{
          disabled: isMutating,
          label: t('No, Cancel'),
          onClick: modalProps.onClose,
        }}
      />
    </Modal>
  );
};
